import { defineMessages } from 'react-intl';

export default defineMessages({
  continueWith: {
    id: 'social.login.form.continue-button',
    defaultMessage: 'Continue with {socialProviderName}',
    description:
      'Button label that is a CTA for users to continue logging in using the selected social provider.',
  },
});
